import { axiosInstance } from '@/components/axiosInstance'
import type {
  DonorDetails,
  ApiErrorDetailsResponse,
  ApiSignUpStatusResponse,
} from '@/types'
import {
  setPreferHeader,
  type Headers,
} from '@/components/setAxiosPreferHeader'

/**
 *
 * @param url
 * @param donorDetails
 *
 * If API testing you can set prefer headers by including
 * a headers object, e.g.
    const response = await axiosInstance.post(url, donorDetails, {
      headers: {
        Prefer: 'statusCode=400,example=ValidationFailure',
      },
      validateStatus: function (status) {
        return status < 500
      },
    })
 */
export const postDonorDetails = async (
  url: string,
  donorDetails: DonorDetails
): Promise<ApiErrorDetailsResponse | ApiSignUpStatusResponse> => {
  const headers: Headers = {
    ...setPreferHeader(window.location.search),
  }

  try {
    const response = await axiosInstance.post(url, donorDetails, {
      headers,
      validateStatus: function (status: number) {
        return status < 500
      },
    })

    return response.data
  } catch (error: any) {
    console.error('Error', error)
    return {
      status: 520, // Borrowing CloudFlare number
      title: 'Unknown Error',
      detail: 'An unknown error occurred',
      errors: ['An unknown error occurred'],
    }
  }
}

export default postDonorDetails
